import { render, staticRenderFns } from "./PropertyGeneral.vue?vue&type=template&id=56bbcda1"
import script from "./PropertyGeneral.vue?vue&type=script&lang=js"
export * from "./PropertyGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports